export default __webpack_public_path__ + "static/media/stfrancisassisi.daa19910.jpg";